/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { util } from "../../../../shared/util";

class DropZoneMultipleField extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
      })),
    ]).isRequired,
  };

  constructor() {
    super();
    this.state = {
      filenames: []
    };
    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(files) {
    const { onChange } = this.props;
    const { filenames } = this.state;
    files.sort((a, b) => (a.path.toLowerCase() > b.path.toLowerCase()) ? 1 : -1);
    filenames.sort((a, b) => (a.toLowerCase() > b.toLowerCase()) ? 1 : -1);
    onChange(files.map(fl => Object.assign(fl, {
      preview: URL.createObjectURL(fl),
    })));
  }

  removeFile= (index, e) => {
    const { value, onChange } = this.props;
    const { filenames } = this.state;
    e.preventDefault();
    filenames.splice(index, 1);
    onChange(value.filter((val, i) => i !== index));
  };

  render() {
    const { name, value } = this.props;
    const { filenames } = this.state;
    const files = value;

    let txts = util.getDropZoneInfoHere();

    return (
      <div className="dropzone dropzone--multiple">
        <Dropzone
          className="dropzone__input"
          accept=".zip"
          name={name}
          onDrop={(filesToUpload) => {
            this.onDrop(value ? value.concat(filesToUpload) : filesToUpload);
          }}
          validator={(fileToUpload) => {
            if(filenames.includes(fileToUpload.path)){
              return true;
            }else{
              filenames.push(fileToUpload.path);
              return false;
            }
          }}
        >
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()} className="dropzone__input">
              {(!files || files.length === 0)
              && (
                <div className="dropzone__drop-here">
                  <span className="lnr lnr-upload" /> {txts.infohere}
                </div>
              )}
              <input {...getInputProps()} />
            </div>
          )}
        </Dropzone>
        {files && Array.isArray(files)
        && (
        <div className="dropzone__files-wrapper">
          {files.map((file, i) => (
            <div className="dropzone__file" key={i} >
              <p className="dropzone__file-name">{file.name.substr(0,file.name.length-4)}</p>
              <p className="dropzone__file-name_footer">shape zip</p>
              <button className="dropzone__file-delete" type="button" onClick={e => this.removeFile(i, e)}>
                {txts.remove}
              </button>
            </div>
          ))}
        </div>
        )}
      </div>
    );
  }
}

const renderDropZoneMultipleField = (props) => {
  const { input } = props;
  return (
    <DropZoneMultipleField
      {...input}
    />
  );
};

renderDropZoneMultipleField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
};

export default renderDropZoneMultipleField;
